import React from "react";
import { graphql } from "gatsby";
import { PageTemplate } from "@maison-graciet/gatsby-gco-lib/templates";
import Wrapper from "../components/wrapper";

const Page = (props) => {
  return (
    <Wrapper>
      <PageTemplate {...props} />
    </Wrapper>
  );
};

export const query = graphql`
  query ($id: String!) {
    ...PageTemplate
    ...AllSettings
    ...Map
    ...AllFilters
  }
`;

export default Page;
